"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.differenceInDays = exports.isDate = exports.parse = exports.format = void 0;
const format_1 = __importDefault(require("date-fns/format"));
const isValid_1 = __importDefault(require("date-fns/isValid"));
const parseISO_1 = __importDefault(require("date-fns/parseISO"));
const parseJSON_1 = __importDefault(require("date-fns/parseJSON"));
const differenceInDays_1 = __importDefault(require("date-fns/differenceInDays"));
exports.differenceInDays = differenceInDays_1.default;
const format = (input, format = 'datetime') => {
    const date = (typeof input === 'string') ? (0, exports.parse)(input) : input;
    if (format === 'date') {
        return formatDate(date);
    }
    if (format === 'datetime') {
        return `${formatDate(date)} ${formatTime(date)}`;
    }
    if (format === 'dayOfTheWeek') {
        return (0, format_1.default)(date, 'EEEE');
    }
    if (format === 'time') {
        return formatTime(date);
    }
    if (format === 'database') {
        return (0, format_1.default)(date, 'yyyy-MM-dd hh:mm:ss');
    }
    return (0, format_1.default)(date, format);
};
exports.format = format;
const formatDate = (date) => (0, format_1.default)(date, 'MM/dd/yyyy');
const formatTime = (date) => (0, format_1.default)(date, 'h:mm aaa');
const parse = (dateString) => (0, parseISO_1.default)(dateString);
exports.parse = parse;
const isDate = (input) => typeof input === 'string' && (0, isValid_1.default)((0, parseJSON_1.default)(input)); // eslint-disable-line @typescript-eslint/no-explicit-any
exports.isDate = isDate;
__exportStar(require("./types"), exports);
